<template>
	<div id="layout-default">
		<HeaderMain />
		<slot />
		<FooterMain />
		<ClientOnly>
			<BranchInfoBar />
		</ClientOnly>
	</div>
</template>
